import Logo from '@/assets/images/Logo.png';
import { Box, styled } from '@mui/material';
interface AuthContainerProps {}

const ContentBox = styled(Box)({
	display: 'flex',
	marginTop: '150px',
	justifyContent: 'center',
	height: '100vh',
});

export default function AuthContainer(
	props: React.PropsWithChildren<AuthContainerProps>
) {
	return (
		<>
			<ContentBox sx={{ background: 'background.default' }}>
				{props.children}
			</ContentBox>
		</>
	);
}
